// styles
import classes from './styles.module.scss'

// types
import type { FC, ReactNode, HTMLProps, MouseEventHandler } from 'react'
import type { variantsEnum } from '@centria-ui/commons/enums'
import type { size, weight, tagName } from './utils'

export interface TypographyProps extends HTMLProps<HTMLElement> {
  testId?: string
  children?: ReactNode
  Tag?: keyof typeof tagName
  fontSize?: keyof typeof size
  fontWeight?: keyof typeof weight
  fontcolor?: keyof typeof variantsEnum
  onClick?: MouseEventHandler<HTMLElement>
}

export const Typography: FC<TypographyProps> = ({
  onClick,
  htmlFor,
  children,
  Tag = 'p',
  fontWeight,
  testId = '',
  className = '',
  fontSize = 'body',
  fontcolor = 'dark'
}) => {
  return (
    <Tag
      data-cy={testId}
      htmlFor={htmlFor}
      onClick={onClick}
      role={onClick && 'button'}
      className={`${classes.typography} ${classes[`typography_${fontSize}`]} ${
        classes[`typography_color_${fontcolor}`]
      } ${classes[`typography_${fontWeight}`]} ${
        onClick ? classes.typography_onClick : ''
      } ${className}`}>
      {children}
    </Tag>
  )
}
